"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DateTimeRange = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _DateTimePicker = _interopRequireDefault(require("../DateTimePicker"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText/ErrorHandlingFormHelperText"));

var _Range = _interopRequireDefault(require("../Range"));

var _Recurrence = _interopRequireDefault(require("./Recurrence"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DateTimeRange = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DateTimeRange, _Component);

  var _super = _createSuper(DateTimeRange);

  function DateTimeRange() {
    var _this;

    (0, _classCallCheck2.default)(this, DateTimeRange);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeDateRange", function (e, value) {
      var onChange = _this.props.onChange;

      _this.setState({
        from: value.from,
        to: value.to
      }, function () {
        onChange && onChange(e, _this.state);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeRecurrence", function (updatedRecurrence, e) {
      var onChange = _this.props.onChange;

      _this.setState({
        recurrence: updatedRecurrence
      }, function () {
        onChange && onChange(e, _this.state);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          autoFocus = _this$props.autoFocus,
          disabled = _this$props.disabled,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          format = _this$props.format,
          fromProps = _this$props.fromProps,
          id = _this$props.id,
          helperText = _this$props.helperText,
          label = _this$props.label,
          locale = _this$props.locale,
          maxValue = _this$props.maxValue,
          minValue = _this$props.minValue,
          onBlur = _this$props.onBlur,
          required = _this$props.required,
          toProps = _this$props.toProps,
          value = _this$props.value,
          pickerType = _this$props.pickerType,
          keyboard = _this$props.keyboard,
          executeValidation = _this$props.executeValidation,
          allowRecurring = _this$props.allowRecurring,
          className = _this$props.className,
          fullWidth = _this$props.fullWidth;
      var errorGlobal = typeof error === "string" ? error : (error === null || error === void 0 ? void 0 : error.to) || (error === null || error === void 0 ? void 0 : error.from);
      var onlyErrorString = !(error === null || error === void 0 ? void 0 : error.from) && !(error === null || error === void 0 ? void 0 : error.to) && error;
      var onlyErrorMessageString = typeof errorMessage === "string" ? errorMessage : false;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "prmbl-dateTimeRange-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_Range.default, {
        autoFocus: autoFocus,
        disabled: disabled,
        component: _DateTimePicker.default,
        executeValidation: executeValidation,
        errorMessage: errorMessage,
        fromProps: _objectSpread({
          errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.from,
          error: error === null || error === void 0 ? void 0 : error.from,
          format: format,
          locale: locale,
          minValue: fromProps.minValue || minValue,
          maxValue: fromProps.maxValue || maxValue,
          pickerType: pickerType,
          keyboard: keyboard,
          fullWidth: fullWidth
        }, fromProps),
        error: errorGlobal,
        id: id,
        className: "prmbl-dateTimeRange ".concat(className),
        label: label,
        onChange: _this.onChangeDateRange,
        onBlur: onBlur,
        required: required,
        toProps: _objectSpread({
          errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.to,
          error: error === null || error === void 0 ? void 0 : error.to,
          format: format,
          locale: locale,
          minValue: toProps.minValue || minValue,
          maxValue: toProps.maxValue || maxValue,
          pickerType: pickerType,
          keyboard: keyboard,
          fullWidth: fullWidth
        }, toProps),
        value: value
      }), allowRecurring && /*#__PURE__*/_react.default.createElement(_Recurrence.default, {
        error: onlyErrorString,
        errorMessage: errorMessage,
        required: required,
        id: id ? id : undefined,
        onChange: _this.onChangeRecurrence,
        executeValidation: executeValidation
      }), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: id ? "".concat(id, "-datetime-range-error-handling-helper-text") : undefined,
        helperText: helperText,
        error: onlyErrorString,
        errorMessage: onlyErrorMessageString
      }));
    });
    return _this;
  }

  return DateTimeRange;
}(_react.Component);

exports.DateTimeRange = DateTimeRange;
(0, _defineProperty2.default)(DateTimeRange, "propTypes", {
  /**
   * If `true`, displays recurring options for DateTimeRange.
   */
  allowRecurring: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    from: _propTypes.default.bool,
    to: _propTypes.default.bool
  })]),

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    from: _propTypes.default.string,
    to: _propTypes.default.string
  })]),

  /**
   * If `true` the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * The format in which the date will be displayed
   */
  format: _propTypes.default.string,

  /**
   * Container to store all the properties for the `from` component
   */
  fromProps: _propTypes.default.shape({
    /**
     * Sets the label for the component
     */
    label: _propTypes.default.node,

    /**
     * Makes the input span the entire component's width
     */
    fullWidth: _propTypes.default.bool,

    /**
     * The placeholder for the `From` input.
     */
    placeholder: _propTypes.default.string,

    /**
     * When `true`, indicates that the component is required
     */
    required: _propTypes.default.bool,

    /**
     * Overrides top level. Set a desired end date for the Date. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select future dates.
     */
    maxValue: _propTypes.default.instanceOf(Date),

    /**
     * Overrides top level. Set a desired start-date for the DateTimePicker. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select past dates.
     */
    minValue: _propTypes.default.instanceOf(Date)
  }),

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.node,

  /**
   * The locale to use when formating dates.
   * Default is en-us locale. To set a different locale, import the locale object from date-fns.
   * Example: import dateFnsItLocale from "date-fns/locale/it";
   */
  locale: _propTypes.default.object,

  /**
   * Set a desired end date for the Date. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select future dates.
   */
  maxValue: _propTypes.default.instanceOf(Date),

  /**
   * Set a desired start-date for the DateTimePicker. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select past dates.
   */
  minValue: _propTypes.default.instanceOf(Date),

  /**
   * Callback fired when the value is changed.  `function(event: object, value: object) => void`
   *
   * `event` : The event source of the callback.
   *
   *
   * `value` : The value of the range. { from: ..., to: ... }
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * Callback to be called when the user switches focus from the input
   *
   * function(event: object) => void
   * event: The orginating event of the callback
   */
  onBlur: _propTypes.default.func,

  /**
   * Function passed in from /Validation/index.js.. Used to bypass the checks inside index.js and call validation directly.
   */
  executeValidation: _propTypes.default.func,

  /**
   * Sets the component as required.
   */
  required: _propTypes.default.bool,

  /**
   * Container to store all the properties for the `to` component
   */
  toProps: _propTypes.default.shape({
    /**
     * Sets the label for the component
     */
    label: _propTypes.default.node,

    /**
     * Makes the input span the entire component's width
     */
    fullWidth: _propTypes.default.bool,

    /**
     * The placeholder for the `To` input.
     */
    placeholder: _propTypes.default.string,

    /**
     * When `true`, indicates that the component is required
     */
    required: _propTypes.default.bool,

    /**
     * Overrides top level. Set a desired end date for the Date. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select future dates.
     */
    maxValue: _propTypes.default.instanceOf(Date),

    /**
     * Overrides top level. Set a desired start-date for the DateTimePicker. The `Date()` function can be used. Use `{new Date()}` to dis-allow the user to select past dates.
     */
    minValue: _propTypes.default.instanceOf(Date)
  }),

  /**
   * The value of the range object
   */
  value: _propTypes.default.shape({
    /**
     * Value of the `From` input
     */
    from: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),

    /**
     * Value of the `To` input
     */
    to: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string])
  }),

  /**
   * The type of picker to use, one of: dateTime, date, time.
   */
  pickerType: _propTypes.default.oneOf(["dateTime", "date", "time"]),

  /**
   * Set to true to allow keyboard input. The picker opens on click of an added icon to the text field.
   */
  keyboard: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Makes both inputs span the entire component's width
   */
  fullWidth: _propTypes.default.bool
});
(0, _defineProperty2.default)(DateTimeRange, "defaultProps", {
  toProps: {},
  fromProps: {},
  format: "M/d/yyyy",
  locale: _enUS.default,
  pickerType: "date",
  className: "",
  id: ""
});
var _default = DateTimeRange;
exports.default = _default;